module.exports = __webpack_public_path__ + "static/img/co_cde__dept_white_v.20a0b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/co_cde__dept_white_v.png
// module id = /39e
// module chunks = 3